import Link from 'next/link'

import styled from 'styled-components'
import {
  height,
  HeightProps,
  padding,
  PaddingProps,
  position,
  PositionProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'
import { Z_INDICES } from 'Constants/ZIndices'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<HeightProps & PaddingProps & PositionProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${themeGet('colors.background.screen')};
  z-index: ${Z_INDICES.HEADER};
  box-shadow: ${themeGet('shadows.header')};

  ${position}
  ${height}
  ${padding}
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.7')}px;
`

export const PhoneLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.2')}px;
  color: ${themeGet('colors.secondary.main')};
  text-decoration: none;
`
